import { apiJson } from "../../api/request.js";
import type {
  CreateSeasonInput,
  ChangeSeasonRulesInput,
  SeasonListResponse,
  SeasonResponse,
  BindSeasonSlotInput,
  SeasonAccess,
  SeasonAdminCandidate,
  SeasonAdminCommand,
  SeasonTitleInput,
} from "../../../shared/contracts/season.js";
const base = "/api/v1/seasons";
export const seasonAccess = () =>
  apiJson<SeasonAccess>("/api/v1/season-access");
export const listAdminSeasons = () =>
  apiJson<SeasonListResponse>("/api/v1/admin/seasons");
export const seasonAdminCandidates = (id: string, memberId?: string) =>
  apiJson<{ candidates: SeasonAdminCandidate[] }>(
    `/api/v1/admin/seasons/${encodeURIComponent(id)}/candidates${memberId ? `?memberId=${encodeURIComponent(memberId)}` : ""}`,
  );
export const administerSeason = (id: string, body: SeasonAdminCommand) =>
  apiJson<SeasonResponse>(
    `/api/v1/admin/seasons/${encodeURIComponent(id)}/manage`,
    { method: "POST", body },
  );
export const agreeTitleMatch = (id: string, body: SeasonTitleInput) =>
  apiJson<SeasonResponse>(`${base}/${encodeURIComponent(id)}/title-match`, {
    method: "POST",
    body,
  });
export const listSeasons = () => apiJson<SeasonListResponse>(base);
export const getSeason = (id: string) =>
  apiJson<SeasonResponse>(`${base}/${encodeURIComponent(id)}`);
export const createSeason = (body: CreateSeasonInput) =>
  apiJson<SeasonResponse>(base, { method: "POST", body });
export const acceptSeason = (id: string, expectedVersion: number) =>
  apiJson<SeasonResponse>(`${base}/${encodeURIComponent(id)}/accept`, {
    method: "POST",
    body: { expectedVersion },
  });
export const changeSeasonRules = (id: string, body: ChangeSeasonRulesInput) =>
  apiJson<SeasonResponse>(`${base}/${encodeURIComponent(id)}/rules`, {
    method: "PATCH",
    body,
  });
export const bindSeasonSlot = (
  id: string,
  slotId: string,
  body: BindSeasonSlotInput,
) =>
  apiJson<SeasonResponse>(
    `${base}/${encodeURIComponent(id)}/slots/${encodeURIComponent(slotId)}/bind`,
    { method: "POST", body },
  );
